document.querySelector('.product__thumb-arrow--custom').addEventListener('click', function() {
  var index = parseInt(document.getElementById('index_now').innerHTML) + 1;
  var total = parseInt(document.getElementById('total_thumbs').innerHTML);

  if (index > total) {
    document.getElementById('index_now').innerHTML = 1;
  } else {
    document.getElementById('index_now').innerHTML = index;
  }
  
});

if(document.querySelector('.jdgm-prev-badge')) {
document.querySelector('.jdgm-prev-badge').addEventListener('click', function() {
  document.getElementById('shopify-section-template--14823694073898__1680802521089be579').scrollIntoView({ behavior: "smooth"});
});
}
